import React from "react";

import { Weather, WindDegree } from "@/models/weather";

type Props = {
  weather: Weather;
  color?: "white" | "gray";
};

export const WindDegreeIcon = ({ weather, color }: Props) => {
  return (
    <img
      className="w-[20px] h-[20px]"
      src={color === "white" ? "./img/icon-wind-direction-white.svg" : "./img/icon-wind-direction-gray.svg"}
      alt="wind"
      style={{ transform: `rotate(${WindDegree[weather.wind_degree]?.degree ?? 0}deg)` }}
    />
  );
};
